export default __webpack_public_path__ + "static/media/Template_2_dark.20be4dd5.svg";